export const CREATE_WHATSAPP_TRIAL_MESSAGE_REQUEST = "CREATE_WHATSAPP_TRIAL_MESSAGE_REQUEST";
export const CREATE_WHATSAPP_TRIAL_MESSAGE_SUCCESS = "CREATE_WHATSAPP_TRIAL_MESSAGE_SUCCESS";
export const CREATE_WHATSAPP_TRIAL_MESSAGE_FAILURE = "CREATE_WHATSAPP_TRIAL_MESSAGE_FAILURE";
export const CREATE_WHATSAPP_TRIAL_MESSAGE_RESET = "CREATE_WHATSAPP_TRIAL_MESSAGE_RESET";
export const createWhatsappTrialMessageDataRequest = (payload) => ({
    type: CREATE_WHATSAPP_TRIAL_MESSAGE_REQUEST,
    payload,
});
export const createWhatsappTrialMessageDataSuccess = (payload) => ({
    type: CREATE_WHATSAPP_TRIAL_MESSAGE_SUCCESS,
    payload,
});
export const createWhatsappTrialMessageDataFailure = (error) => ({
    type: CREATE_WHATSAPP_TRIAL_MESSAGE_FAILURE,
    payload: error,
});
export const createWhatsappTrialMessageDataReset = () => ({
    type: CREATE_WHATSAPP_TRIAL_MESSAGE_RESET,
});
